// IC Builder Pro v1.5.1

document.addEventListener('DOMContentLoaded', function () {
  const root = document.querySelector('.ic-pro');
  if (!root) return;

  const sectionId = root.dataset.sectionId;
  const storageKey = 'charmed_ic_pro_current_' + sectionId;
  const builtKey = 'charmed_ic_pro_built_' + sectionId;
  const cartCountKey = 'charmed_bracelet_cart_count';

  const starters = JSON.parse(document.getElementById('icStarterData-' + sectionId).textContent || '[]');
  const builderFonts = JSON.parse(document.getElementById('icFontData-' + sectionId).textContent || '[]');

  builderFonts.forEach(function (font) {
    const style = document.createElement('style');
    style.textContent = `
      @font-face {
        font-family: "${font.family}";
        src: url("${font.url}") format("woff2");
        font-display: swap;
      }
    `;
    document.head.appendChild(style);
  });
const PHOTO_UPLOAD_URL =
  'https://charmed-bracelet-shortener.monique707.workers.dev/photo';
  const slotsEl = document.getElementById('icBraceletSlots');
  const starterSelected = document.getElementById('icStarterSelected');
  const starterOptions = document.getElementById('icStarterOptions');
  const starterSelectedImage = document.getElementById('icStarterSelectedImage');
  const starterSelectedTitle = document.getElementById('icStarterSelectedTitle');
  const sizeSelector = document.getElementById('icSizeSelector');
  const braceletNameInput = document.getElementById('icBraceletName');

  const drawer = document.getElementById('icCharmDrawer');
  const closeDrawer = document.getElementById('icCloseDrawer');
  const charmsGrid = document.getElementById('icCharmsGrid');
  const collectionSelector = document.getElementById('icCollectionSelector');
  const searchInput = document.getElementById('icCharmSearch');

  const charmPickerView = document.getElementById('icCharmPickerView');
  const engravingView = document.getElementById('icEngravingView');
  const backToCharms = document.getElementById('icBackToCharms');
  const engravingTitle = document.getElementById('icEngravingTitle');
  const engravingImage = document.getElementById('icEngravingImage');
  const engravingText = document.getElementById('icEngravingText');
  const engravingCount = document.getElementById('icEngravingCount');
  const fontOptions = document.getElementById('icFontOptions');
  const addEngravedCharmBtn = document.getElementById('icAddEngravedCharm');

  const photoView = document.getElementById('icPhotoView');
const backFromPhoto = document.getElementById('icBackFromPhoto');
const photoTitle = document.getElementById('icPhotoTitle');
const photoCharmImage = document.getElementById('icPhotoCharmImage');
const photoUpload = document.getElementById('icPhotoUpload');
const photoEditor = document.getElementById('icPhotoEditor');
const photoPreview = document.getElementById('icPhotoPreview');
const photoZoom = document.getElementById('icPhotoZoom');
const addPhotoCharmBtn = document.getElementById('icAddPhotoCharm');

  const saveBtn = document.getElementById('icSaveBracelet');
  const shareBtn = document.getElementById('icShareBracelet');
  const clearBtn = document.getElementById('icClearBracelet');
  const cartBtn = document.getElementById('icAddToCart');
  const saveMessage = document.getElementById('icSaveMessage');

  const editPopup = document.getElementById('icEditPopup');
  const editPopupTitle = document.getElementById('icEditPopupTitle');
  const replaceCharmBtn = document.getElementById('icReplaceCharm');
  const removeCharmBtn = document.getElementById('icRemoveCharm');
  const cancelEditBtn = document.getElementById('icCancelEditCharm');

  const builtPanel = document.getElementById('icBuiltBraceletsPanel');
  const builtList = document.getElementById('icBuiltBraceletsList');

  let starterIndex = 0;
  let braceletSize = 18;
  let braceletName = '';
  let selectedCharms = Array(braceletSize).fill(null);
  let activeSlotIndex = null;
  let editingSlotIndex = null;
  let loadedProducts = [];
  let allProducts = [];
let loadedCollections = {};
  let pendingEngravedCharm = null;
  let selectedFontIndex = 0;
  let pendingPhotoCharm = null;
let uploadedPhotoDataUrl = '';
let photoScale = 1;
let photoOffsetX = 0;
let photoOffsetY = 0;
let photoDragging = false;
let photoDragStartX = 0;
let photoDragStartY = 0;

  function money(cents) {
    return 'R' + (Number(cents || 0) / 100).toFixed(2);
  }

  function currentStarter() {
    return starters[starterIndex] || null;
  }

  function isRealCharm(item) {
    return item && !item.covered;
  }

  function getCharmCount() {
    return selectedCharms.filter(isRealCharm).length;
  }

  function getBlankCount() {
    return selectedCharms.filter(function (item) {
      return item === null;
    }).length;
  }

  function getTotal() {
    const starter = currentStarter();
    const blankTotal = starter ? Number(starter.price) * getBlankCount() : 0;

    const charmTotal = selectedCharms.reduce(function (sum, item) {
      return sum + (isRealCharm(item) ? Number(item.price || 0) : 0);
    }, 0);

    return blankTotal + charmTotal;
  }

  function productHasTag(product, tagName) {
    if (!product.tags) return false;

    if (Array.isArray(product.tags)) {
      return product.tags.includes(tagName);
    }

    return String(product.tags)
      .split(',')
      .map(function (tag) {
        return tag.trim();
      })
      .includes(tagName);
  }

  function getCurrentDesign() {
    return {
      starterIndex: starterIndex,
      braceletSize: braceletSize,
      braceletName: braceletName,
      selectedCharms: selectedCharms
    };
  }

  function normaliseCharmsArray() {
    selectedCharms = selectedCharms.slice(0, braceletSize);

    while (selectedCharms.length < braceletSize) {
      selectedCharms.push(null);
    }
  }

  function applyDesign(data) {
    if (!data) return;

    starterIndex = Number(data.starterIndex || 0);
    if (starterIndex >= starters.length) starterIndex = 0;

    braceletSize = Number(data.braceletSize || 18);
    sizeSelector.value = String(braceletSize);

    braceletName = data.braceletName || '';
    braceletNameInput.value = braceletName;

    selectedCharms = Array.isArray(data.selectedCharms)
      ? data.selectedCharms.slice(0, braceletSize)
      : Array(braceletSize).fill(null);

    normaliseCharmsArray();
  }

  function saveCurrent(showMessage) {
    localStorage.setItem(storageKey, JSON.stringify(getCurrentDesign()));

    if (showMessage) {
      saveMessage.textContent = 'Your bracelet has been saved on this device.';
      setTimeout(function () {
        saveMessage.textContent = '';
      }, 3000);
    }
  }

  function loadCurrent() {
    const urlParams = new URLSearchParams(window.location.search);
    const sharedDesign = urlParams.get('design');

    try {
      if (sharedDesign) {
        const decoded = JSON.parse(decodeURIComponent(escape(atob(sharedDesign))));
        applyDesign(decoded);
        saveCurrent(false);
        saveMessage.textContent = 'Shared bracelet design loaded.';
        return;
      }

      const saved = localStorage.getItem(storageKey);
      if (saved) {
        applyDesign(JSON.parse(saved));
        saveMessage.textContent = 'Welcome back! We restored your saved bracelet.';
      }
    } catch (error) {
      console.warn('Could not restore bracelet design', error);
    }
  }

  function getBuiltBracelets() {
    try {
      return JSON.parse(localStorage.getItem(builtKey) || '[]');
    } catch (error) {
      return [];
    }
  }

  function saveBuiltBracelets(items) {
    localStorage.setItem(builtKey, JSON.stringify(items));
  }

  function getBraceletLabel(fallbackNumber) {
    return braceletName.trim() || 'Bracelet ' + fallbackNumber;
  }

  function updatePreviewHeading() {
    const name = braceletName.trim();
    document.getElementById('icPreviewHeading').textContent = name ? name + "'s Bracelet" : 'Your Bracelet';
  }

  function updateHelperText() {
    const helper = document.getElementById('icHelperText');
    const charmCount = getCharmCount();

    if (charmCount === 0) {
      helper.textContent = 'Tap any blank link on your bracelet to choose your first charm.';
    } else if (getBlankCount() === 0) {
      helper.textContent = 'Your bracelet is full. Tap a charm to replace or remove it.';
    } else {
      helper.textContent = 'Tap a blank link to add another charm, or tap a charm to replace or remove it.';
    }
  }

  function buildStarterDropdown() {
    starterOptions.innerHTML = '';

    starters.forEach(function (starter, index) {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'ic-visual-option';

      button.innerHTML =
        (starter.image ? '<img src="' + starter.image + '" alt="' + starter.title + '">' : '') +
        '<span>' + starter.title + '</span>';

      button.addEventListener('click', function () {
        starterIndex = index;
        starterOptions.classList.remove('open');
        updateBracelet();
      });

      starterOptions.appendChild(button);
    });
  }

  function updateStarterSelected() {
    const starter = currentStarter();

    if (!starter) {
      starterSelectedTitle.textContent = 'Select starter bracelet';
      starterSelectedImage.style.display = 'none';
      return;
    }

    starterSelectedTitle.textContent = starter.title;

    if (starter.image) {
      starterSelectedImage.src = starter.image;
      starterSelectedImage.style.display = 'block';
    } else {
      starterSelectedImage.style.display = 'none';
    }
  }

  function getStartIndex(index) {
    const item = selectedCharms[index];

    if (!item) return index;
    if (item.covered) return item.parentIndex;

    return index;
  }

  function clearCharmAt(index) {
    const startIndex = getStartIndex(index);
    const item = selectedCharms[startIndex];

    if (!isRealCharm(item)) return;

    const size = Number(item.slotSize || 1);

    for (let i = 0; i < size; i++) {
      selectedCharms[startIndex + i] = null;
    }
  }

  function canPlaceCharmAt(index, slotSize) {
    if (index + slotSize > braceletSize) return false;

    for (let i = 0; i < slotSize; i++) {
      if (selectedCharms[index + i] !== null) return false;
    }

    return true;
  }

  function placeCharmAt(index, charm) {
    index = getStartIndex(index);

    clearCharmAt(index);

    const slotSize = Number(charm.slotSize || 1);

    if (!canPlaceCharmAt(index, slotSize)) {
      alert(slotSize === 2 ? 'This double charm needs 2 open links next to each other.' : 'This space is not available.');
      return false;
    }

    selectedCharms[index] = charm;

    if (slotSize === 2) {
      selectedCharms[index + 1] = {
        covered: true,
        parentIndex: index
      };
    }

    return true;
  }

  function closeEditPopup() {
    editPopup.classList.remove('open');
    editingSlotIndex = null;
  }

  function openEditPopup(index, slotElement) {
    const startIndex = getStartIndex(index);
    const charm = selectedCharms[startIndex];

    if (!isRealCharm(charm)) return;

    editingSlotIndex = startIndex;
    editPopupTitle.textContent = charm.title;

    const rect = slotElement.getBoundingClientRect();
    editPopup.style.left = Math.min(rect.left, window.innerWidth - 210) + 'px';
    editPopup.style.top = Math.max(rect.top - 150, 20) + 'px';
    editPopup.classList.add('open');
  }

  function fitEngravingText(element, item) {
    if (!element) return;

    const isDouble = Number(item.slotSize || 1) === 2;

    // Fixed engraving area.
    const maxWidth = isDouble ? 78 : 38;
    const maxHeight = isDouble ? 36 : 30;

    // Start large and reduce only when the actual selected font needs it.
    let fontSize = isDouble ? 20 : 15;
    const minFontSize = isDouble ? 7 : 6;

    element.style.width = maxWidth + 'px';
    element.style.maxWidth = maxWidth + 'px';
    element.style.height = maxHeight + 'px';
    element.style.fontSize = fontSize + 'px';

    while (
      (element.scrollWidth > maxWidth || element.scrollHeight > maxHeight) &&
      fontSize > minFontSize
    ) {
      fontSize -= 0.5;
      element.style.fontSize = fontSize + 'px';
    }
  }

  function updateBracelet() {
  const starter = currentStarter();

  updateStarterSelected();
  updatePreviewHeading();
  updateHelperText();

  slotsEl.innerHTML = '';
  slotsEl.style.gridTemplateColumns =
    'repeat(' + braceletSize + ', 48px)';

  selectedCharms.forEach(function (item, index) {
    if (item && item.covered) return;

    const slot = document.createElement('div');
    slot.className = 'ic-slot';
    slot.dataset.index = index;

    if (
      isRealCharm(item) &&
      Number(item.slotSize || 1) === 2
    ) {
      slot.classList.add('ic-slot-double');
      slot.style.gridColumn = 'span 2';
    }

  if (isRealCharm(item)) {
  const img = document.createElement('img');

  // Photo charm: show customer's cropped photo
  if (
    item.type === 'photo' &&
    (item.photoPreview || item.photoUrl)
  ) {
    img.src = item.photoPreview || item.photoUrl;
  } else {
    img.src = item.image;
  }

  img.alt = item.title || 'Charm';

  const imageWrapper = document.createElement('div');
  imageWrapper.className = 'ic-slot-image-wrapper';

  // Special image crop for engraved double / Superlink charms
 if (
  item.type === 'engraved' &&
  Number(item.slotSize || 1) === 2
) {
  imageWrapper.classList.add(
    'ic-engraved-double-image'
  );
}

  imageWrapper.appendChild(img);
  slot.appendChild(imageWrapper);

  // Live engraved text
  if (
    item.type === 'engraved' &&
    item.engravingText
  ) {
    const engravingOverlay =
      document.createElement('span');

    engravingOverlay.className =
      'ic-slot-engraving';

    engravingOverlay.textContent =
      item.engravingText;
      const engravingLines = item.engravingText.split('\n');

if (engravingLines.length > 1) {
  engravingOverlay.classList.add('ic-engraving-two-lines');
}

    if (item.engravingFontFamily) {
      engravingOverlay.style.fontFamily =
        '"' +
        item.engravingFontFamily +
        '"';
    }

    slot.appendChild(engravingOverlay);

    // Wait until the font/text exists in the DOM,
    // then fit the actual rendered font into the area.
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        fitEngravingText(engravingOverlay, item);
      });
    });
  }

} else if (starter && starter.image) {
  const img = document.createElement('img');

  img.src = starter.image;
  img.alt = starter.title || 'Starter bracelet';

  const imageWrapper = document.createElement('div');
  imageWrapper.className = 'ic-slot-image-wrapper';

  imageWrapper.appendChild(img);
  slot.appendChild(imageWrapper);

    } else {
      slot.textContent = '+';
    }

    slot.addEventListener('click', function (event) {
      event.stopPropagation();

      if (isRealCharm(selectedCharms[index])) {
        openEditPopup(index, slot);
      } else {
        activeSlotIndex = index;

        showCharmPicker();
        drawer.classList.add('open');

        if (
          collectionSelector &&
          collectionSelector.value
        ) {
          loadCollectionProducts(
            collectionSelector.value
          );
        }
      }
    });

    slotsEl.appendChild(slot);
  });

  document.getElementById('icBraceletSummary').textContent =
    getCharmCount() +
    ' charms · ' +
    getBlankCount() +
    ' blank links';

  document.getElementById('icSummaryStarter').textContent =
    starter ? starter.title : '-';

  document.getElementById('icSummarySize').textContent =
    braceletSize + ' links';

  document.getElementById('icSummaryCharms').textContent =
    getCharmCount();

  document.getElementById('icSummaryBlanks').textContent =
    getBlankCount();

  document.getElementById('icSummaryTotal').textContent =
    money(getTotal());

  saveCurrent(false);
}

 function createCharmCard(product, collectionHandle) {
  const variant = product.variants[0];

  if (!variant || !variant.available) {
    return '';
  }

  // Check charm type first
  const engraved =
    productHasTag(product, 'bbengraved');

  const photoCharm =
    productHasTag(product, 'bbphoto');

  const slotSize =
    productHasTag(product, 'slot_2')
      ? 2
      : 1;

  // First product image:
  // Used in the charm selection drawer
  const image =
    product.images && product.images.length
      ? product.images[0].src
      : '';

  // Second product image:
  // Used on the bracelet preview for engraved charms.
  //
  // If there is no second image, it automatically
  // falls back to the first image.
  const braceletImage =
    engraved &&
    product.images &&
    product.images.length > 1
      ? product.images[1].src
      : image;

  const price =
    Math.round(Number(variant.price) * 100);

  return (
    '<div class="ic-charm-card" ' +

      'data-collection="' +
        collectionHandle +
      '" ' +

      'data-title="' +
        product.title
          .toLowerCase()
          .replace(/"/g, '&quot;') +
      '" ' +

      'data-display-title="' +
        product.title
          .replace(/"/g, '&quot;') +
      '" ' +

      'data-price="' +
        price +
      '" ' +

      'data-variant-id="' +
        variant.id +
      '" ' +

      'data-slot-size="' +
        slotSize +
      '" ' +

      'data-engraved="' +
        engraved +
      '" ' +

      'data-photo="' +
        photoCharm +
      '" ' +

      // IMPORTANT:
      // This is the image that gets saved onto
      // the charm when the customer selects it.
      'data-image="' +
        braceletImage +
      '">' +

      // IMPORTANT:
      // Keep showing IMAGE 1 in the charm picker.
      (
        image
          ? '<img src="' +
              image +
              '" alt="' +
              product.title +
              '" loading="lazy">'
          : ''
      ) +

      '<h3>' +
        product.title +
      '</h3>' +

      (
        slotSize === 2
          ? '<p class="ic-double-note">Double charm · uses 2 links</p>'
          : ''
      ) +

      (
        engraved
          ? '<p class="ic-double-note">Personalised charm</p>'
          : ''
      ) +

      (
        photoCharm
          ? '<p class="ic-double-note">Photo charm</p>'
          : ''
      ) +

      '<p class="ic-price">' +
        money(price) +
      '</p>' +

      '<button type="button">Choose</button>' +

    '</div>'
  );
}

  async function loadCollectionProducts(collectionHandle) {

  // Already cached
  if (loadedCollections[collectionHandle]) {
    loadedProducts = loadedCollections[collectionHandle];
    renderProducts(collectionHandle);
    return;
  }

  charmsGrid.innerHTML = '<p class="ic-loading">Loading charms...</p>';

  let page = 1;
  loadedProducts = [];

  while (true) {

    const response = await fetch(
      '/collections/' + collectionHandle + '/products.json?limit=250&page=' + page
    );

    const data = await response.json();

    if (!data.products || data.products.length === 0) break;

    loadedProducts = loadedProducts.concat(data.products);

    page++;

  }

  loadedCollections[collectionHandle] = loadedProducts;

  loadedProducts.forEach(function(product){

      if(!allProducts.find(function(p){
          return p.id === product.id;
      })){
          allProducts.push(product);
      }

  });

  renderProducts(collectionHandle);

}

  function renderProducts(collectionHandle) {
    const searchTerm = searchInput.value.toLowerCase().trim();

    const productsToSearch =
    searchTerm.length > 0
        ? allProducts
        : loadedProducts;

const html = productsToSearch
    .filter(function(product){
        return product.title.toLowerCase().includes(searchTerm);
    })
    .map(function(product){
        return createCharmCard(product, collectionHandle);
    })
    .join('');

    charmsGrid.innerHTML = html || '<p class="ic-loading">No charms found.</p>';
    attachCharmButtons();
  }

  function showCharmPicker() {
  charmPickerView.hidden = false;

  if (engravingView) {
    engravingView.hidden = true;
  }

  if (photoView) {
    photoView.hidden = true;
  }

  pendingEngravedCharm = null;
  pendingPhotoCharm = null;
}
function createCroppedPhotoBlob() {
  return new Promise(function (resolve, reject) {
    if (!photoPreview || !photoPreview.src) {
      reject(new Error('No photo has been selected.'));
      return;
    }

    const img = new Image();

    img.onload = function () {
      const outputSize = 800;

      const canvas = document.createElement('canvas');
      canvas.width = outputSize;
      canvas.height = outputSize;

      const ctx = canvas.getContext('2d');

      if (!ctx) {
        reject(new Error('Photo processing is not supported.'));
        return;
      }

      /*
       * The crop box uses object-fit: contain.
       *
       * Work out how large the original image appears inside
       * the 240px crop area before customer zoom/positioning.
       */
      const cropElement =
        document.querySelector('.ic-photo-crop');

      if (!cropElement) {
        reject(new Error('Photo crop area could not be found.'));
        return;
      }

      const cropWidth = cropElement.clientWidth;
      const cropHeight = cropElement.clientHeight;

      const naturalWidth = img.naturalWidth;
      const naturalHeight = img.naturalHeight;

      const containScale = Math.min(
        cropWidth / naturalWidth,
        cropHeight / naturalHeight
      );

      const displayedWidth =
        naturalWidth * containScale * photoScale;

      const displayedHeight =
        naturalHeight * containScale * photoScale;

      /*
       * Convert the browser preview coordinates to
       * our 800 × 800 output canvas.
       */
      const outputRatio =
        outputSize / cropWidth;

      const drawWidth =
        displayedWidth * outputRatio;

      const drawHeight =
        displayedHeight * outputRatio;

      const drawX =
        ((cropWidth - displayedWidth) / 2 +
          photoOffsetX) *
        outputRatio;

      const drawY =
        ((cropHeight - displayedHeight) / 2 +
          photoOffsetY) *
        outputRatio;

      /*
       * White background prevents transparent areas
       * becoming black when converted to JPEG.
       */
      ctx.fillStyle = '#ffffff';
      ctx.fillRect(
        0,
        0,
        outputSize,
        outputSize
      );

      ctx.drawImage(
        img,
        drawX,
        drawY,
        drawWidth,
        drawHeight
      );

      canvas.toBlob(
        function (blob) {
          if (!blob) {
            reject(
              new Error(
                'The cropped photo could not be created.'
              )
            );
            return;
          }

          resolve(blob);
        },
        'image/jpeg',
        0.9
      );
    };

    img.onerror = function () {
      reject(
        new Error('The uploaded photo could not be processed.')
      );
    };

    img.src = photoPreview.src;
  });
}
async function uploadCroppedPhoto(blob) {
  const response = await fetch(
    PHOTO_UPLOAD_URL,
    {
      method: 'POST',

      headers: {
        'Content-Type': 'image/jpeg'
      },

      body: blob
    }
  );

  let result;

  try {
    result = await response.json();
  } catch (error) {
    throw new Error(
      'The photo server returned an invalid response.'
    );
  }

  if (
    !response.ok ||
    !result.success ||
    !result.photoUrl
  ) {
    throw new Error(
      result.message ||
      'The photo could not be uploaded.'
    );
  }

  return result.photoUrl;
}
  function showEngravingPanel(charm) {
    pendingEngravedCharm = charm;
    selectedFontIndex = 0;

    const limit = Number(charm.slotSize || 1) === 2 ? 32 : 8;

    charmPickerView.hidden = true;
    engravingView.hidden = false;

    engravingTitle.textContent = charm.title;
    engravingImage.src = charm.image;
    engravingImage.alt = charm.title;
    engravingText.value = '';
    engravingCount.textContent = '0 / ' + limit + ' characters';

    renderFontOptions();
    engravingText.focus();
  }

  function renderFontOptions() {
    const previewText = engravingText.value || 'Name';
    fontOptions.innerHTML = '';

    if (!builderFonts.length) {
      fontOptions.innerHTML = '<p class="ic-loading">No fonts added yet.</p>';
      return;
    }

    builderFonts.forEach(function (font, index) {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'ic-font-option' + (index === selectedFontIndex ? ' active' : '');

      button.innerHTML =
        '<span class="ic-font-preview" style="font-family:\'' + font.family + '\'">' + previewText + '</span>' +
        '<span class="ic-font-name">' + font.name + '</span>';

      button.addEventListener('click', function () {
        selectedFontIndex = index;
        renderFontOptions();
      });

      fontOptions.appendChild(button);
    });
  }
function resetPhotoEditor() {
  uploadedPhotoDataUrl = '';
  photoScale = 1;
  photoOffsetX = 0;
  photoOffsetY = 0;

  if (photoUpload) {
    photoUpload.value = '';
  }

  if (photoPreview) {
    photoPreview.src = '';
    photoPreview.style.transform =
      'translate(-50%, -50%) translate(0px, 0px) scale(1)';
  }

  if (photoZoom) {
    photoZoom.value = '1';
  }

  if (photoEditor) {
    photoEditor.hidden = true;
  }

  if (addPhotoCharmBtn) {
    addPhotoCharmBtn.disabled = true;
  }
}

function showPhotoPanel(charm) {
  pendingPhotoCharm = charm;

  charmPickerView.hidden = true;

  if (engravingView) {
    engravingView.hidden = true;
  }

  photoView.hidden = false;

  photoTitle.textContent = charm.title;
  photoCharmImage.src = charm.image;
  photoCharmImage.alt = charm.title;

  resetPhotoEditor();
}

function updatePhotoTransform() {
  if (!photoPreview) return;

  photoPreview.style.transform =
    'translate(-50%, -50%) ' +
    'translate(' + photoOffsetX + 'px, ' + photoOffsetY + 'px) ' +
    'scale(' + photoScale + ')';
}

function loadPhotoFile(file) {
  if (!file) return;

  const allowedTypes = [
    'image/jpeg',
    'image/png',
    'image/webp'
  ];

  if (!allowedTypes.includes(file.type)) {
    alert('Please upload a JPG, PNG or WEBP image.');
    return;
  }

  const reader = new FileReader();

  reader.onload = function (event) {
    uploadedPhotoDataUrl = event.target.result;

    photoPreview.src = uploadedPhotoDataUrl;

    photoScale = 1;
    photoOffsetX = 0;
    photoOffsetY = 0;

    photoZoom.value = '1';
    photoEditor.hidden = false;
    addPhotoCharmBtn.disabled = false;

    updatePhotoTransform();
  };

  reader.readAsDataURL(file);
}

async function addPendingPhotoCharm() {
  if (
    !pendingPhotoCharm ||
    !uploadedPhotoDataUrl
  ) {
    alert('Please upload a photo first.');
    return;
  }

  const originalButtonText =
    addPhotoCharmBtn.textContent;

  try {
    addPhotoCharmBtn.disabled = true;
    addPhotoCharmBtn.textContent =
      'Uploading photo...';

    /*
     * Create the exact crop the customer positioned.
     */
    const croppedBlob =
      await createCroppedPhotoBlob();

    /*
     * Upload the cropped JPEG to Cloudflare R2.
     */
    const photoUrl =
      await uploadCroppedPhoto(croppedBlob);

    /*
     * Store the permanent photo URL on the charm.
     */
    const charm = Object.assign(
      {},
      pendingPhotoCharm,
      {
        type: 'photo',

        photoUrl: photoUrl,

        /*
         * We keep the temporary preview as well so
         * we can use it immediately in the builder.
         */
        photoPreview:
          URL.createObjectURL(croppedBlob)
      }
    );

    const placed =
      placeCharmAt(
        activeSlotIndex,
        charm
      );

    if (!placed) {
      throw new Error(
        'There is not enough space for this photo charm.'
      );
    }

    pendingPhotoCharm = null;
    activeSlotIndex = null;

    drawer.classList.remove('open');

    showCharmPicker();

    updateBracelet();

  } catch (error) {
    console.error(
      'Photo charm error:',
      error
    );

    alert(
      error.message ||
      'The photo could not be added. Please try again.'
    );

  } finally {
    addPhotoCharmBtn.disabled = false;
    addPhotoCharmBtn.textContent =
      originalButtonText;
  }
}
  function attachCharmButtons() {
    document.querySelectorAll('.ic-charm-card button').forEach(function (button) {
      button.addEventListener('click', function () {
        const card = this.closest('.ic-charm-card');

        if (activeSlotIndex === null) {
          activeSlotIndex = selectedCharms.findIndex(function (item) {
            return item === null;
          });
        }

        if (activeSlotIndex === -1 || activeSlotIndex === null) {
          alert('Your bracelet is full.');
          return;
        }

        let charmType = 'standard';

if (card.dataset.engraved === 'true') {
  charmType = 'engraved';
}

if (card.dataset.photo === 'true') {
  charmType = 'photo';
}

const charm = {
  title: card.dataset.displayTitle,
  price: card.dataset.price,
  variantId: card.dataset.variantId,
  image: card.dataset.image,
  slotSize: Number(card.dataset.slotSize || 1),
  type: charmType
};


        if (charm.type === 'engraved') {
          showEngravingPanel(charm);
          return;
        }
        if (charm.type === 'photo') {
  showPhotoPanel(charm);
  return;
}

        const placed = placeCharmAt(activeSlotIndex, charm);
        if (!placed) return;

        activeSlotIndex = null;
        drawer.classList.remove('open');
        updateBracelet();
      });
    });
  }

  function addPendingEngravedCharm() {
    if (!pendingEngravedCharm) return;

    const text = engravingText.value.trim();

    if (!text) {
      alert('Please enter the engraving text.');
      return;
    }

    const font = builderFonts[selectedFontIndex];

    if (!font) {
      alert('Please add at least one Builder Font block.');
      return;
    }

    const charm = Object.assign({}, pendingEngravedCharm, {
      engravingText: text,
      engravingFont: font.name,
      engravingFontFamily: font.family
    });

    const placed = placeCharmAt(activeSlotIndex, charm);
    if (!placed) return;

    pendingEngravedCharm = null;
    activeSlotIndex = null;
    drawer.classList.remove('open');
    showCharmPicker();
    updateBracelet();
  }

  function renderBuiltBracelets() {
    const built = getBuiltBracelets();

    if (!built.length) {
      builtPanel.hidden = true;
      builtList.innerHTML = '';
      return;
    }

    builtPanel.hidden = false;
    builtList.innerHTML = '';

    built.forEach(function (item, index) {
      const starter = starters[item.starterIndex] || {};
      const charmCount = (item.selectedCharms || []).filter(isRealCharm).length;

      const card = document.createElement('div');
      card.className = 'ic-built-card';

      card.innerHTML =
        '<div>' +
        '<h3>' + item.label + '</h3>' +
        '<p>' + (starter.title || 'Starter bracelet') + ' · ' + item.braceletSize + ' links · ' + charmCount + ' charms</p>' +
        '</div>' +
        '<div class="ic-built-actions">' +
        '<button type="button" data-action="edit">Edit</button>' +
'<button type="button" data-action="duplicate">Duplicate</button>' +
'<button type="button" data-action="delete">Delete</button>' +
        '</div>';

     card.querySelector('[data-action="edit"]').addEventListener('click', function () {
  applyDesign(item);
  updateBracelet();

  saveMessage.innerHTML =
    '📝 <strong>Editing: ' + item.label + '</strong><br>' +
    'Remember: This creates a new version of your bracelet. After adding the updated bracelet to your cart, remove the previous version to avoid ordering both.';

  saveMessage.classList.add('ic-edit-warning');

  window.scrollTo({
    top: document.querySelector('.ic-preview').offsetTop - 30,
    behavior: 'smooth'
  });
});

      card.querySelector('[data-action="duplicate"]').addEventListener('click', function () {
        applyDesign(item);
        braceletNameInput.value = item.label + ' copy';
        braceletName = braceletNameInput.value;
        updateBracelet();
        saveMessage.textContent = 'Duplicated ' + item.label + '. You can now make changes.';
      });
      card.querySelector('[data-action="delete"]').addEventListener('click', function () {
  const confirmDelete = confirm('Remove ' + item.label + ' from this list? This will not remove it from your Shopify cart.');

  if (!confirmDelete) return;

  const updated = getBuiltBracelets().filter(function (_, builtIndex) {
    return builtIndex !== index;
  });

  saveBuiltBracelets(updated);
  renderBuiltBracelets();
});

      builtList.appendChild(card);
    });
  }

  function addCurrentToBuiltPanel(label) {
    const built = getBuiltBracelets();

    built.push({
      label: label,
      starterIndex: starterIndex,
      braceletSize: braceletSize,
      braceletName: braceletName,
      selectedCharms: selectedCharms
    });

    saveBuiltBracelets(built);
    renderBuiltBracelets();
  }

  starterSelected.addEventListener('click', function () {
    starterOptions.classList.toggle('open');
  });

  document.addEventListener('click', function (event) {
    if (!document.getElementById('icStarterSelect').contains(event.target)) {
      starterOptions.classList.remove('open');
    }

    if (!editPopup.contains(event.target) && !event.target.closest('.ic-slot')) {
      closeEditPopup();
    }
  });

  sizeSelector.addEventListener('change', function () {
    braceletSize = Number(this.value);
    selectedCharms = selectedCharms.slice(0, braceletSize);

    while (selectedCharms.length < braceletSize) {
      selectedCharms.push(null);
    }

    updateBracelet();
  });

  braceletNameInput.addEventListener('input', function () {
    braceletName = this.value;
    updateBracelet();
  });

  if (collectionSelector) {
    collectionSelector.addEventListener('change', function () {
      loadCollectionProducts(this.value);
    });
  }
async function preloadCollections() {
  if (!collectionSelector) return;

  const options = collectionSelector.querySelectorAll('option');

  for (const option of options) {
    if (!loadedCollections[option.value]) {
      await loadCollectionProducts(option.value);
    }
  }
}
  if (searchInput) {
    searchInput.addEventListener('input', async function () {
  if (searchInput.value.trim().length > 0) {
    await preloadCollections();
  }

  renderProducts(collectionSelector.value);
});
  }

  closeDrawer.addEventListener('click', function () {
    drawer.classList.remove('open');
    activeSlotIndex = null;
    showCharmPicker();
  });

  backToCharms.addEventListener('click', showCharmPicker);

  engravingText.addEventListener('input', function () {
  if (!pendingEngravedCharm) return;

  const limit =
    Number(pendingEngravedCharm.slotSize || 1) === 2
      ? 32
      : 8;

  let value = engravingText.value;

  // Maximum of 2 lines
  let lines = value.split('\n');

  if (lines.length > 2) {
    lines = lines.slice(0, 2);
    value = lines.join('\n');
  }

  // Count characters without counting the line break
  const plainText = value.replace(/\n/g, '');

  if (plainText.length > limit) {
    let remaining = limit;

    lines = value.split('\n').map(function (line) {
      const allowed = line.slice(0, remaining);
      remaining -= allowed.length;
      return allowed;
    });

    value = lines.join('\n');
  }

  engravingText.value = value;

  const characterCount =
    value.replace(/\n/g, '').length;

  engravingCount.textContent =
    characterCount +
    ' / ' +
    limit +
    ' characters · max 2 lines';

  renderFontOptions();
});

  addEngravedCharmBtn.addEventListener('click', addPendingEngravedCharm);
  if (backFromPhoto) {
  backFromPhoto.addEventListener('click', showCharmPicker);
}

if (photoUpload) {
  photoUpload.addEventListener('change', function () {
    const file = this.files && this.files[0];

    if (file) {
      loadPhotoFile(file);
    }
  });
}

if (photoZoom) {
  photoZoom.addEventListener('input', function () {
    photoScale = Number(this.value || 1);
    updatePhotoTransform();
  });
}

if (addPhotoCharmBtn) {
  addPhotoCharmBtn.addEventListener(
    'click',
    addPendingPhotoCharm
  );
}
const photoCrop = document.querySelector('.ic-photo-crop');

if (photoCrop) {
  photoCrop.addEventListener('pointerdown', function (event) {
    if (!uploadedPhotoDataUrl) return;

    photoDragging = true;
    photoDragStartX = event.clientX - photoOffsetX;
    photoDragStartY = event.clientY - photoOffsetY;

    photoCrop.setPointerCapture(event.pointerId);
  });

  photoCrop.addEventListener('pointermove', function (event) {
    if (!photoDragging) return;

    photoOffsetX = event.clientX - photoDragStartX;
    photoOffsetY = event.clientY - photoDragStartY;

    updatePhotoTransform();
  });

  photoCrop.addEventListener('pointerup', function () {
    photoDragging = false;
  });

  photoCrop.addEventListener('pointercancel', function () {
    photoDragging = false;
  });
}

  replaceCharmBtn.addEventListener('click', function () {
    if (editingSlotIndex === null) return;

    activeSlotIndex = editingSlotIndex;
    closeEditPopup();
    showCharmPicker();
    drawer.classList.add('open');

    preloadCollections();
  });

  removeCharmBtn.addEventListener('click', function () {
    if (editingSlotIndex === null) return;

    clearCharmAt(editingSlotIndex);
    closeEditPopup();
    updateBracelet();
  });

  cancelEditBtn.addEventListener('click', closeEditPopup);

  clearBtn.addEventListener('click', function () {
    selectedCharms = Array(braceletSize).fill(null);
    braceletName = '';
    braceletNameInput.value = '';
    saveCurrent(true);
    updateBracelet();
  });

  saveBtn.addEventListener('click', function () {
    saveCurrent(true);
  });
function showShareLink(url, copied) {
  saveMessage.innerHTML =
    '<strong>' + (copied ? 'Share link copied!' : 'Share your bracelet') + '</strong><br>' +
    '<input id="icShareLinkInput" value="' + url + '" readonly style="width:100%;margin-top:8px;padding:10px;border:1px solid #ddd;border-radius:8px;font-size:12px;">' +
    '<small>Copy this link to share your bracelet design.</small>';

  saveMessage.classList.remove('ic-edit-warning');
  saveMessage.classList.add('ic-share-box');

  setTimeout(function () {
    const input = document.getElementById('icShareLinkInput');
    if (input) {
      input.focus();
      input.select();
    }
  }, 50);
}
 shareBtn.addEventListener('click', function () {
  const encoded = btoa(unescape(encodeURIComponent(JSON.stringify(getCurrentDesign()))));
  const url = window.location.origin + window.location.pathname + '?design=' + encoded;

  if (navigator.share) {
    navigator.share({
      title: 'My Charmed Bracelet',
      text: 'I designed a bracelet on Charmed Jewellery 💕',
      url: url
    }).catch(function () {
      showShareLink(url);
    });
  } else if (navigator.clipboard) {
    navigator.clipboard.writeText(url).then(function () {
      showShareLink(url, true);
    }).catch(function () {
      showShareLink(url, false);
    });
  } else {
    showShareLink(url, false);
  }
});

  cartBtn.addEventListener('click', function () {
    const starter = currentStarter();

    if (!starter || !starter.variantId) {
      alert('Please add at least one starter bracelet option in the section settings.');
      return;
    }

    const currentCount = Number(sessionStorage.getItem(cartCountKey) || 0) + 1;
    sessionStorage.setItem(cartCountKey, currentCount);

    const braceletId = Date.now().toString().slice(-6);
    const braceletLabel = getBraceletLabel(currentCount);
    const items = [];

    selectedCharms.forEach(function (item, index) {
      if (!isRealCharm(item)) return;

      const slotSize = Number(item.slotSize || 1);
      const position = slotSize === 2 ? (index + 1) + '-' + (index + 2) : index + 1;

      const properties = {
        '_builder_id': braceletId,
        'Bracelet': braceletLabel,
        'Position': position
      };

      if (item.type === 'engraved') {
        properties['Engraving Text'] = item.engravingText;
        properties['Font'] = item.engravingFont;
      }
      if (item.type === 'photo' && item.photoUrl) {
  properties['Customer Photo'] = item.photoUrl;
}

      items.push({
        id: Number(item.variantId),
        quantity: 1,
        properties: properties
      });
    });

    const blankPositions = selectedCharms
      .map(function (item, index) {
        return item === null ? index + 1 : null;
      })
      .filter(Boolean)
      .join(', ');

    if (getBlankCount() > 0) {
      items.push({
        id: Number(starter.variantId),
        quantity: getBlankCount(),
        properties: {
          '_builder_id': braceletId,
          'Bracelet': braceletLabel,
          'Blank Positions': blankPositions
        }
      });
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (response) {
        return response.json();
      })
      .then(function () {
        addCurrentToBuiltPanel(braceletLabel);

        saveMessage.textContent = braceletLabel + ' has been added to your cart. You can now build another bracelet.';

        selectedCharms = Array(braceletSize).fill(null);
        braceletName = '';
        braceletNameInput.value = '';
        activeSlotIndex = null;

        saveCurrent(false);
        updateBracelet();

        setTimeout(function () {
          saveMessage.textContent = '';
        }, 5000);
      })
      .catch(function () {
        alert('Something went wrong. Please try again.');
      });
  });

  buildStarterDropdown();
  loadCurrent();
  updateBracelet();
  renderBuiltBracelets();

  if (collectionSelector && collectionSelector.value) {
    loadCollectionProducts(collectionSelector.value);
  }
  setTimeout(function () {
  if (window.Sortable) {
    new Sortable(slotsEl, {
      animation: 150,
      draggable: '.ic-slot',
      onEnd: function () {
        const newOrder = [];

        document.querySelectorAll('.ic-slot').forEach(function (slot) {
          const oldIndex = Number(slot.dataset.index);
          const item = selectedCharms[oldIndex];

          if (isRealCharm(item)) {
            newOrder.push(item);

            if (Number(item.slotSize || 1) === 2) {
              newOrder.push({
                covered: true,
                parentIndex: newOrder.length - 1
              });
            }
          } else {
            newOrder.push(null);
          }
        });

        selectedCharms = newOrder.slice(0, braceletSize);

        while (selectedCharms.length < braceletSize) {
          selectedCharms.push(null);
        }

        updateBracelet();
      }
    });
  }
}, 500);
});